import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { RADIO_PLAN_DESC } from '@app/core/models/Radio';
import { RootBac } from '@app/library/models/bac.model';
import { exportSecMin, planBigger, TimeSplited } from '@app/shared/utils';
import { SearchBarComponent } from '@radioking/ui/input';

@Component({
  selector: 'rk-library-header',
  templateUrl: './library-header.component.html',
  styleUrls: ['./library-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibraryHeaderComponent {
  @Input()
  currentBac: RootBac;

  @Input()
  tracksTime: number;

  @Input()
  isCurrentlyFiltered = false;

  @Input()
  displayedTracks: number;

  @Output()
  readonly changeSearch = new EventEmitter();

  @Input()
  fullHeader = true;

  @Input()
  plan: RADIO_PLAN_DESC;

  @Input()
  shoutOutsEnabled = 1;

  @ViewChild('searchBar')
  searchBar: SearchBarComponent;

  currentSearchValue: string;

  chronicsUrl =
    'https://www.radioking.com/on/knowledgebase/110/Horaires-des-chroniques.html';

  clearSearchBar() {
    if (this.searchBar) {
      this.searchBar.value = '';
    }
  }

  editSearch(e: string) {
    if (typeof e === 'string') {
      this.currentSearchValue = e;
      this.changeSearch.emit(e);
    }
  }

  clickButton() {
    window.open(this.chronicsUrl, '_blank');
  }

  getMinutesAndHours(value: number): TimeSplited {
    return exportSecMin(value);
  }

  planBigger(plan: RADIO_PLAN_DESC, compareTo: RADIO_PLAN_DESC) {
    return planBigger(plan, compareTo);
  }
}
